import { mapMutations } from "vuex";
let pressTimer = null;
let el = null;

export default {
  methods: {
    longPressStart(e) {
      // 定义函数处理程序
      // 创建计时器
      if (
        (e.type === "click" && e.button !== 0) ||
        !e.target.closest(".block__block") //确保按倒的是块
      ) {
        return;
      }

      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // 执行函数
          this.handleLongPress(e);
        }, 500);
      }
    },
    longPressCancelLongPress() {
      // 取消计时器

      // 检查计时器是否有值
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    },
    longPressCancelMul() {
      this.longPressCancelLongPress();
      //取消多选
      this.cancelMultiSel();
    },
    longPressAddListener() {
      // 添加事件监听器
      ["mousedown", "touchstart"].forEach(event =>
        el.addEventListener(event, this.longPressStart)
      );

      Array("touchend", "touchcancel", "mouseout", "mouseover").forEach(event =>
        el.addEventListener(event, this.longPressCancelLongPress)
      );

      el.addEventListener("mouseup", this.longPressCancelMul);
    },
    longPressRemoveListener() {
      ["mousedown", "touchstart"].forEach(event =>
        el.removeEventListener(event, this.longPressStart)
      );

      Array("touchend", "touchcancel", "mouseout", "mouseover").forEach(event =>
        el.removeEventListener(event, this.longPressCancelLongPress)
      );

      el.removeEventListener("mouseup", this.longPressCancelMul);
    },
    initLongPress() {
      el = document.getElementById("block");
      this.longPressAddListener();
    },
    handleLongPress(event) {
      this.initMultiSel();
      //多选状态信息框位置
      this.$emit("initFloatMsg", { top: event.clientY, left: event.clientX });
    },
    ...mapMutations(["cancelMultiSel", "initMultiSel"])
  }
};
